<template>
  <v-container fluid>
    <v-card class="elevation-2 py-0 px-2 my-6 rounded-lg">
      <v-row class="px-4 pb-6 pt-3">
        <v-col cols="12" lg="1" class="pb-0">
          <v-select
              :items="yearsSelect"
              v-model="yearsSelected"
              item-value="value"
              item-text="text"
              label="Year"
              outlined
              hide-details
              dense
              :disabled="loaded"
          >
          </v-select>
          <v-spacer></v-spacer>
        </v-col>
        <v-col cols="12" lg="3" class="pb-0">
          <v-select
              :items="graphs"
              v-model="selectedGraphs"
              item-value="value"
              item-text="text"
              label="All graphs"
              outlined
              hide-details
              dense chips multiple
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2" text-color="white" :color="item.color">
                <span>{{ item.descr }}</span>
              </v-chip>
              <span
                  v-if="index === 2"
                  class="grey--text caption"
              >
              (+{{ selectedGraphs.length - 2 }} {{ (selectedGraphs.length - 2) > 1 ? 'others' : 'another' }})
            </span>
            </template>
            <template v-slot:item="{ active, item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row no-gutters align="center">
                      <span>{{ item.text }}</span>
                      <v-spacer></v-spacer>
                      <v-chip text-color="white" :color="item.color" small>{{ item.descr }}</v-chip>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:prepend-item>
              <v-list-item
                  ripple
                  @click="showAllGraphs"
              >
                <v-list-item-action>
                  <v-icon :color="selectedGraphs.length > 0 ? 'indigo' : ''">
                    {{ allGraphsIcon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    All graphs
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select>
          <v-spacer></v-spacer>
        </v-col>
        <v-col cols="12" lg="3" class="pb-0">
          <v-autocomplete
              v-model="selectedStates"
              multiple
              hide-details
              :items="states"
              label="Selected Geo Area"
              item-text="name"
              outlined
              show-select
              dense
              class="text-body-2 text-capitalize mx-0 my-0 pr-0 pb-0"
              @change="applyFilters"
              tags
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2" text-color="white" :color="item.color">
                <span>{{ item.name }}</span>
              </v-chip>
              <span
                  v-if="index === 2"
                  class="grey--text caption"
              >
                (+{{ selectedProducts.length - 2 }} others)
              </span>
            </template>
            <template v-slot:item="{ active, item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row no-gutters align="center">
                      <span>{{ item.name }}</span>
                      <v-spacer></v-spacer>
                      <v-icon :color="item.color" dense class="ml-auto">mdi-circle</v-icon>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:prepend-item>
              <v-list-item @click="showAllStates">
                <v-list-item-action>
                  <v-icon :color="selectedStates.length > 0 ? 'indigo' : ''">
                    {{ allGeoIcon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Select All
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" lg="5" class="pb-0">
          <v-autocomplete
              v-model="selectedProducts"
              multiple
              hide-details
              :items="products"
              label="Selected Products"
              item-text="name"
              outlined
              show-select
              dense
              class="text-body-2 text-capitalize mx-0 my-0 pr-0 pb-0"
              @change="applyFilters"
              tags
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2" text-color="white" :color="item.color">
                <span>{{ item.name }}</span>
              </v-chip>
              <span
                  v-if="index === 2"
                  class="grey--text caption"
              >
                (+{{ selectedProducts.length - 2 }} others)
              </span>
            </template>
            <template v-slot:item="{ active, item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row no-gutters align="center">
                      <span>{{ item.name }}</span>
                      <v-spacer></v-spacer>
                      <v-icon :color="item.color" dense class="ml-auto">mdi-circle</v-icon>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:prepend-item>
              <v-list-item @click="showAllProducts">
                <v-list-item-action>
                  <v-icon :color="selectedProducts.length > 0 ? 'indigo' : ''">
                    {{ allProductsIcon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    All products
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-show="selectedGraphs.includes('orders') && selectedStates.length > 0" class="elevation-2 py-3 px-3 mt-4 rounded-lg">
      <v-row>
        <v-col cols="12" class="ml-3">
          <h2>Orders</h2>
        </v-col>
        <v-col cols="12">
          <v-progress-linear
              indeterminate
              color="indigo"
              v-if="loaded"
          ></v-progress-linear>
        </v-col>
        <v-col cols="12" md="12">
          <highcharts :options="chartOptionsOrders"></highcharts>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-show="selectedGraphs.includes('gallons') && selectedStates.length > 0" class="elevation-2 py-3 px-3 mt-4 rounded-lg">
      <v-row>
        <v-col cols="12" class="ml-3">
          <h2>Gallons</h2>
        </v-col>
        <v-col cols="12">
          <v-progress-linear
              indeterminate
              color="indigo"
              v-if="loaded"
          ></v-progress-linear>
        </v-col>
        <v-col cols="12" md="12">
          <highcharts :options="chartOptionsGallons"></highcharts>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-show="selectedGraphs.includes('sales') && selectedStates.length > 0" class="elevation-2 py-3 px-3 mt-4 rounded-lg">
      <v-row>
        <v-col cols="12" class="ml-3">
          <h2>Sales (filter by products are not applied)</h2>
        </v-col>
        <v-col cols="12">
          <v-progress-linear
              indeterminate
              color="indigo"
              v-if="loaded"
          ></v-progress-linear>
        </v-col>
        <v-col cols="12" md="12">
          <highcharts :options="chartOptionsSales"></highcharts>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import {Chart} from 'highcharts-vue'

export default {
  components: {
    highcharts: Chart
  },
  data() {
    return {
      updateArgs: [true, true, true],
      chartOptionsOrders: {
        chart: {
          height: 500,
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        xAxis: {
          gridLineWidth: 1,
          categories: [],
          crosshair: true,
        },

        yAxis: {
          min: 0,
          title: {
            text: 'Orders'
          },
          endOnTick: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            pointRange: 1.5

          }
        },
        series: []
      },
      chartOptionsGallons: {
        chart: {
          height: 500,
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
          labelFormatter: function () {
            return this.name;
          }
        },
        xAxis: {
          gridLineWidth: 1,
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Gallons'
          },
          endOnTick: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            pointRange: 1.5,
            stacking: 'normal',
          }
        },
        series: []
      },
      chartOptionsSales: {
        chart: {
          height: 500,
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
          labelFormatter: function () {
            return this.name;
          }
        },
         tooltip: {
          formatter: function () {
            let tip = `<b>${this.x}</b>`
            tip += `<br/>${this.series.name}: $${this.y.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>`
            return tip
          },
        },
        xAxis: {
          gridLineWidth: 1,
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Sales'
          },
          endOnTick: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            pointRange: 1.5,
            stacking: 'normal',
          }
        },
        series: []
      },
      allActivitiesOptions: ['Total Orders', 'New Customers', 'Recurrent Customers', 'Total Gallons', 'Total Price'],
      selectedOptions: ['Total Orders', 'New Customers', 'Recurrent Customers', 'Total Gallons', 'Total Price'],
      selected: [],
      data: [],
      copper_data: [],
      filteredData: [],
      historyChanged: [],
      userName: null,
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      loaded: false,
      colors: [
        '#EA6565', '#FF9D9D', '#A75E5E', '#EA704A', '#FBC17D', '#FDED9C', '#43A357',
        '#2AC0AC', '#D5E7B1', '#A1E296', '#B9E7F5', '#398BD8', '#96BCF3', '#8166D0',
        '#9C4B9D', '#B386C5', '#ECD3FF', '#F988D9', '#F86499', '#C264F8',

        '#bf449b', '#940008', '#b956b8', '#2333b1', '#b80443', '#84d05e', '#848d0b',
        '#9b092c', '#c3483f', '#39ee63', '#c72950', '#766cfe', '#067685', '#9b0219',
        '#2856bf', '#c2cc62', '#bfc771', '#a6115c', '#ab5e46', '#c4787b', '#879ddb',
        '#2c0788', '#796a64', '#5081cf', '#3c615e', '#0e5e9e', '#b589e7', '#3562c2', '#a50b12',
        '#69926f', '#68c46d', '#8ec514', '#b6d6d5', '#c57286', '#3f1bc0', '#135078',
        '#8abdc4', '#c27f0f', '#69d8d5', '#94a1a8', '#9e7cc4'
      ],
      states: [],
      selectedStates: [],
      products: [],
      selectedProducts: [],
      graphs: [
        {text: 'Orders', value: 'orders', descr: 'Orders', color: '#6372c3'},
        {text: 'Gallons', value: 'gallons', descr: 'Gallons', color: '#43A357'},
        {text: 'Sales', value: 'sales', descr: 'Sales', color: '#a37943'}
      ],
      yearsSelect: [],
      yearsSelected: '',
      selectedGraphs: ['orders', 'gallons', 'sales'],
      groupByYear: [],
      compaignsByCompaign: [],
      selectedYear: new Date().getFullYear(),
      years: [],
      dataAllActivity: [],
      dataOrders: [],
      dataOrdersCustomerType: [],
      dataOrdersCopperCustomerType: [],
      dataGallons: [],
      dataGallonsCustomerType: [],
      dataGallonsCopperCustomerType: [],
      dataSales: [],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    }
  },
  created() {
  },
  mounted() {
    this.yearsSelected = new Date().getFullYear();

    for (let i = this.yearsSelected; i >= 2021; i--) {
      this.yearsSelect.push(
          {text: i, value: i, descr: i}
      )
    }

    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }
    this.getProducts()
  },
  watch: {
    yearsSelected() {
      this.getProducts()
    }
  },
  computed: {
    allGraphsIcon() {
      if (this.selectedGraphs.length == this.graphs.length) return 'mdi-close-box'
      if (this.selectedGraphs.length < this.graphs.length) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allProductsIcon() {
      if (this.selectedProducts.length == this.products.length) return 'mdi-close-box'
      if (this.selectedProducts.length < this.products.length && this.selectedProducts.length > 0) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allGeoIcon() {
      if (this.selectedStates.length == this.states.length) return 'mdi-close-box'
      if (this.selectedStates.length < this.states.length && this.selectedStates.length > 0) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  methods: {
    sortedChartRender: function (series) {
      if (series.length === 0) return
      var longestSeries = series[0],
          sortedPoints = [],
          selectedPoints = [];

      // find a series with the highest amount of points
      series.forEach(function (s) {
        if (s.points.length > longestSeries.points.length) {
          longestSeries = s;
        }
      });

      longestSeries.points.forEach(function (point) {
        series.forEach(function (s) {
          selectedPoints.push(s.points[point.index]);
        });

        sortedPoints = selectedPoints.slice().sort(function (a, b) {
          b = b.y ? b.y : 0
          a = a.y ? a.y : 0
          return b - a
        });


        selectedPoints.forEach(function (selectedPoint) {

          if (
              selectedPoints.indexOf(selectedPoint) !==
              sortedPoints.indexOf(selectedPoint) &&
              selectedPoint.graphic
          ) {
            // change column position
            selectedPoint.graphic.attr({
              x: selectedPoints[sortedPoints.indexOf(selectedPoint)].shapeArgs.x
            });
          }
        });
        sortedPoints.length = 0;
        selectedPoints.length = 0;
      });

    },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.applyFilters()
    },
    showAllProducts() {

      if (this.selectedProducts.length == this.products.length) {
        this.selectedProducts = []
      } else {
        this.selectedProducts = this.products.slice().map(e => e.name)
      }

      this.applyFilters()
    },
    showAllStates() {

      if (this.selectedStates.length == this.states.length) {
        this.selectedStates = []
      } else {
        this.selectedStates = this.states.slice().map(e => e.name)
      }

      this.applyFilters()
    },
    sumField(table, key, i, isByCustomerType) {
      if (isByCustomerType) {
        let result = []
        result[0] = table.reduce((acc, b) => acc + (b[key] ? (+b[key].split('/')[0] || 0) : 0), 0)
        result[1] = table.reduce((acc, b) => acc + (b[key] ? (+b[key].split('/')[1] || 0) : 0), 0)
        return i == 0 ? 'Total' : result.reduce((acc, e, i) => [...acc, i == 0 ? '' : '/', e].join(''), [])
      }
      return i == 0 ? 'Total' : table.reduce((acc, b) => {
        let a = (typeof b[key] == 'string' ? parseFloat(b[key].replace(/,/g, '')) : b[key]) || 0
        return acc + a
      }, 0)
    },
    sumFieldCopper(table, key, i, isByCustomerType) {
      if (isByCustomerType) {
        let result = []
        result[0] = table.reduce((acc, b) => acc + (b[key] ? (+b[key].split('/')[0] || 0) : 0), 0)
        result[1] = table.reduce((acc, b) => acc + (b[key] ? (+b[key].split('/')[1] || 0) : 0), 0)
        result[2] = table.reduce((acc, b) => acc + (b[key] ? (+b[key].split('/')[2] || 0) : 0), 0)
        return i == 0 ? 'Total' : result.reduce((acc, e, i) => [...acc, i == 0 ? '' : '/', e].join(''), [])
      }
      return i == 0 ? 'Total' : table.reduce((acc, b) => {
        let a = (typeof b[key] == 'string' ? parseFloat(b[key].replace(/,/g, '')) : b[key]) || 0
        return acc + a
      }, 0)
    },
    getColor(i) {
      return this.colors[i]
    },
    getProducts() {
      this.loaded = true
      axios
          .get('/reports/monthly-state-sale/'+this.yearsSelected)
          .then(response => {
            this.data = response.data.data
            this.products = [...new Set(this.data.map(e => e.products
                .map(i => i.map(o => o.name))
            ).flat(Infinity))]
                .slice().sort()
                .map((el, i) => {
                  return {name: el, color: this.colors[i]}
                })

            this.states = [...new Set(this.data.map(e => e.state_name))]
                .slice().sort()
                .map((el, i) => {
                  return {name: el, color: this.colors[i]}
                })

            this.groupByYear = this._.chain(this.data)
                .groupBy("year")
                .map((value, key) => ({label: key, value: value}))
                .value()


            this.years = this.groupByYear.map(e => +e.label).reverse()
            this.selectedYear = this.years[0]

            this.selectedProducts = this.products.slice().map(e => e.name)
            this.statesProducts = this.states.slice().map(e => e.name)
            this.applyFilters()
          })
    },
    applyFilters() {
      this.loaded = true
      this.byState = this._.chain(this.data)
          .groupBy("state_name")
          .map((value, key) => ({label: key, datasets: value.map(i => {
              let p = i.products.filter(el => this.selectedProducts.includes(el[0].name))
              return {
                month: i.month,
                total_orders: p.length,
                total_price: i.total_price,
                total_gallons: p.reduce((acc, e) => acc + e.reduce((acc, i) => acc + i.gallons, 0), 0)
              }
            })
          }))
          .value()

      this.byDate = this._.chain(this.data)
          .groupBy("month")
          .map((value, key) => ({label: this.months[key-1], datasets: value}))
          .value()

      let createChartData = (chart, value1) => {
        chart.xAxis.categories = this.byDate.map(e => e.label)
        let series = this.byState.map(e => {
          return {
            name: e.label,
            data: e.datasets.map(i => i[value1]),
            color: this.states.find(i => i.name === e.label).color
          }
        }).sort((prev, next) => {
          if (prev.name < next.name) return -1
          if (prev.name > next.name) return 1
        })

        let len = chart.xAxis.categories.length

        let fillEmptySeries = series.map(e => {
          let data = []
          for (let i = 0; i < len; i++) {
            if (e.data[i]) {
              data.push(e.data[i])
            } else {
              data.push(0)
            }
          }
          return {
            name: e.name,
            data: data,
            color: e.color
          }
        })

        chart.series = fillEmptySeries

        chart.series = (this.selectedStates.length === 0)
            ? chart.series
            : chart.series.filter(e => this.selectedStates.includes(e.name))
      }

      createChartData(this.chartOptionsOrders, 'total_orders')
      createChartData(this.chartOptionsSales, 'total_price')
      createChartData(this.chartOptionsGallons, 'total_gallons')
      this.loaded = false
    },
    showAllGraphs() {
      this.$nextTick(() => {
        if (this.selectedGraphs.length == this.graphs.length) {
          this.selectedGraphs = []
        } else {
          this.selectedGraphs = this.graphs.slice().map(e => e.value)
        }
      })
    }
  }
}
</script>

<style scoped>
.total-row {
  border-top: 2px solid gray;
}

.v-chip.v-size--default {
  border-radius: 16px;
  font-size: 13px;
  height: 26px;
}

.v-select.v-input--dense .v-chip {
  margin: 4px 4px 0px 4px;
}

.orders {
  line-height: 2.5;
  background-color: rgba(57, 139, 216, 0.3);
}

.gallons {
  line-height: 2.5;
  background-color: rgba(67, 163, 87, 0.3);
}

.price {
  line-height: 2.5;
  background-color: rgba(216, 118, 145, 0.3);
}

.recurrent {
  line-height: 2.5;
  background-color: rgba(88, 106, 206, 0.3);
}

.new {
  line-height: 2.5;
  background-color: rgba(255, 172, 25, 0.3);
}

.v-data-table >>> div > table .text-start {
  padding: 0;
}

.v-data-table >>> div > table tr {
  border: 1px solid black !important;
}
</style>